import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyShokurekishoFormatData,
  provideShokurekishoFormatData,
  type ShokurekishoExampleSentences
} from '@/composables/format-edit/useShokurekishoFormatData'
import {
  provideShokurekishoHistories,
  useShokurekishoHistories
} from '@/composables/format-edit/useShokurekishoHistories'
import ShokurekishoSkillsCard from '@/components/format-edit/shokurekisho/ShokurekishoSkillsCard.vue'
import ShokurekishoCareerJobHistoryCard from '@/components/format-edit/shokurekisho/ShokurekishoCareerJobHistoryCard.vue'
import ShokurekishoJobSummaryCard from '@/components/format-edit/shokurekisho/ShokurekishoJobSummaryCard.vue'
import ShokurekishoPrMessageCard from '@/components/format-edit/shokurekisho/ShokurekishoPrMessageCard.vue'
import ShokurekishoCreateDateCard from '@/components/format-edit/shokurekisho/ShokurekishoCreateDateCard.vue'
import DownloadItem from '@/components/formats/CommonParts/DownloadItem.vue'
import type { BasicData } from '@/utils/format-edit/basicData'

type PaymentLifecycle = {
  init: (host: unknown) => void
  cleanup: (host: unknown) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoCareerEdit',
  props: {
    basicData: null,
    formatId: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any, { expose }) {



const { formLib, vm, yagiprimePaymentService } = useHostServices()

const { formatData, saveKey, saveName, changeCount } = useFormatLocalData({
  saveName: 'shokumukeirekisho',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyShokurekishoFormatData
})
provideShokurekishoFormatData(formatData)

const histories = useShokurekishoHistories(formatData)
provideShokurekishoHistories(histories)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])

const getMode = computed(() => process.env.VUE_APP_MODE)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

const paymentService =
  yagiprimePaymentService as typeof yagiprimePaymentService & PaymentLifecycle

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  if (!formatData.skillsToUse) formatData.skillsToUse = []
  if (!formatData.jobHistories) formatData.jobHistories = []
  paymentService.init(vm)
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
  paymentService.cleanup(vm)
})

expose({
  saveName,
  saveKey,
  formatData,
  changeCount,
  addSkillHistory: histories.addSkillHistory,
  addJobHistory: histories.addJobHistory
})

return { __sfc: true,formLib, vm, yagiprimePaymentService, formatData, saveKey, saveName, changeCount, histories, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, getMode, dataChanged, paymentService, ShokurekishoSkillsCard, ShokurekishoCareerJobHistoryCard, ShokurekishoJobSummaryCard, ShokurekishoPrMessageCard, ShokurekishoCreateDateCard, DownloadItem }
}

})